import { useEffect, useState } from "react";

/**
 * Custom hook to determine if a given media query is matched.
 *
 * @param query - A string representing the media query to be evaluated.
 * @returns An object containing:
 *   - value: A boolean representing if the media query matches.
 *   - isInitialLoading: A boolean representing if the initial loading state is still true.
 */

export function useMediaQuery(query: string) {
  const [value, setValue] = useState<boolean>(false);
  const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true);

  useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener("change", onChange);
    setValue(result.matches);
    setIsInitialLoading(false);

    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return { value, isInitialLoading };
}
